import {isNotNil} from 'ramda';

import type {BulkOperationItem} from '../types/api/bulkOperations';
import type {BulkOperationPresentation} from '../types/BulkOperationPresentation';

export function getBulkOperationRecordLabel(
  resourceId: string,
  item: BulkOperationItem,
  presentation?: BulkOperationPresentation
) {
  const label =
    isNotNil(item.recordLabel) && item.recordLabel.length > 0 ? item.recordLabel : item.recordId;
  return presentation?.getRecordLabel?.(resourceId, item) ?? {linkLabel: label, description: null};
}
